import {observable} from 'mobx'

let _unique_key = 1

export default class DeliveryOption {
    @observable cost = ''
    @observable days = ''
    @observable order_before = ''

    _unique_key

    constructor(option) {
        if (option) {
            this.cost = option.cost
            this.days = option.days
            this.order_before = option.order_before
        }

        this._unique_key = _unique_key++
    }
}